/**
 * @generated SignedSource<<e4f3e66adf39adf046fe2bccb76be271>>
 * @relayHash d6c2686daa320e4eae5d17b06645e593
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5db81d19c5eb16c374ca6e4462f91438e427dd57a0beef1cd4798b60992e1eef

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5db81d19c5eb16c374ca6e4462f91438e427dd57a0beef1cd4798b60992e1eef",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "issueByKey",
            "attachments"
          ]
        }
      ]
    },
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
